import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { LANGS, useLang, setLang } from "@/lib/i18n";

export default function LanguageDropdown() {
  const lang = useLang();
  const [open, setOpen] = useState(false);
  const active = LANGS.find((l) => l.code === lang) || LANGS[0];

  return (
    <div className="relative shrink-0" data-testid="lang-dropdown">
      <button
        data-testid="lang-dropdown-button"
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="listbox"
        aria-expanded={open}
        className="flex items-center gap-1.5 rounded-full border border-[var(--line)] bg-[var(--card)] px-3 py-2 text-xs font-medium text-[var(--text)] shadow-sm hover:border-[#C5A059] transition-colors"
      >
        <img src={active.flag} alt={active.label} className="h-3.5 w-5 rounded-[3px] object-cover" />
        <span className="hidden sm:inline">{active.label}</span>
        <ChevronDown className={`h-3.5 w-3.5 text-[var(--muted)] transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-30" onClick={() => setOpen(false)} />
          <div
            role="listbox"
            className="absolute right-0 z-40 mt-2 w-44 overflow-hidden rounded-xl border border-[#C5A059]/40 bg-[var(--card)] shadow-xl animate-fade-up"
          >
            {LANGS.map((l) => (
              <button
                key={l.code}
                role="option"
                aria-selected={l.code === lang}
                data-testid={`lang-option-${l.code}`}
                onClick={() => {
                  setLang(l.code);
                  setOpen(false);
                }}
                className={`flex w-full items-center gap-2.5 px-4 py-2.5 text-sm transition-colors ${
                  l.code === lang
                    ? "bg-[var(--bg-alt)] text-[var(--bordeaux)] font-semibold"
                    : "text-[var(--text)] hover:bg-[var(--bg-alt)]"
                }`}
              >
                <img src={l.flag} alt="" className="h-4 w-6 rounded-[3px] object-cover" />
                {l.label}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
